import React from 'react';
import { motion } from 'framer-motion';
import { BadgeDivider } from './Badge';
type Tile = {
  img: string;
  alt: string;
  caption: string;
  rotate: string;
  offsetClass: string;
};
const TILES: Tile[] = [{
  img: 'https://cdn.magicpatterns.com/uploads/hd7fbA5PCoxrJZRM63mh5q/Old_dog_BW.png',
  alt: 'Black and white Virtually Unknown dog mascot badge',
  caption: 'Old dogs · new tricks',
  rotate: '-3deg',
  offsetClass: 'sm:ml-2'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/qDTPeaPjRE1VaV2XvADhZ7/VU_TwistedTiki_2026-03-28_StageSetup.jpg',
  alt: 'Virtually Unknown stage setup at Twisted Tiki',
  caption: 'Twisted Tiki · stage setup',
  rotate: '2deg',
  offsetClass: 'sm:-mr-1'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/kfRR5fuaYssmiiSv5AjC4E/Cruise_Ship_Stage.png',
  alt: 'Virtually Unknown performing on a cruise ship stage',
  caption: 'All aboard · cruise stage',
  rotate: '-1.5deg',
  offsetClass: 'sm:ml-1'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/pWNHGN6xq393HDSJpQC4Ar/VU_BandPhoto_PinellasPark.jpg',
  alt: 'Virtually Unknown together in Pinellas Park',
  caption: 'Pinellas Park · the crew',
  rotate: '2.5deg',
  offsetClass: 'sm:-ml-1'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/uCE6cXHHzLZ8QSQ78i6t4v/Record_Deal.png',
  alt: 'Virtually Unknown celebrating a record deal',
  caption: 'The big deal',
  rotate: '-2.5deg',
  offsetClass: 'sm:mr-2'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/4Cmso8zmN7XB3Ju27TaMqJ/VU_diner_B_W.jpg',
  alt: 'Black and white Virtually Unknown band photo in a diner car',
  caption: 'All aboard · black & white',
  rotate: '1.5deg',
  offsetClass: 'sm:ml-2'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/oNiQG9pa3eYP5a9R6KChbX/Nick_and_Frank.jpg',
  alt: 'Nick and Frank posing together with guitars',
  caption: 'Nick & Frank · after hours',
  rotate: '-3.5deg',
  offsetClass: 'sm:-mr-1'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/gHF8HLtkHsqV66D2x189Ch/Oldest_dog.png',
  alt: 'Vintage Virtually Unknown dog mascot graphic',
  caption: 'The oldest dog',
  rotate: '2deg',
  offsetClass: 'sm:ml-1'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/1zzCFKephM3xxahwLtkuZR/VU_Live_Mastrys.jpg',
  alt: 'Virtually Unknown performing live at Mastry’s',
  caption: 'Live at Mastry’s',
  rotate: '-1deg',
  offsetClass: 'sm:mr-1'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/fSKzkoKXv9fbWAoC6yF11Y/VU_AbbeyRoad_HiRes.jpg',
  alt: 'Virtually Unknown crossing Abbey Road with their instruments',
  caption: 'Abbey Road · zebra crossing',
  rotate: '3deg',
  offsetClass: 'sm:-ml-2'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/pN7p3QHKVrfVeodtSBumjz/Band_shot_alt_PP.jpg',
  alt: 'Virtually Unknown gathered outdoors in Pinellas Park',
  caption: 'Pinellas Park · alternate take',
  rotate: '-2deg',
  offsetClass: 'sm:mr-2'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/q1zFLdkEFJPBiEbMxWwfZL/VU_HeroPhoto_Source.jpg',
  alt: 'Virtually Unknown performing on the patio, the original photo behind the hero image',
  caption: 'The original patio session',
  rotate: '1deg',
  offsetClass: 'sm:ml-1'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/u7GjLCkkmuuc9JzWaQ7STY/VU_TwistedTiki_2026-03-28_Selfie.jpg',
  alt: 'Two Virtually Unknown members taking a selfie at Twisted Tiki',
  caption: 'Twisted Tiki · selfie',
  rotate: '-3deg',
  offsetClass: 'sm:-mr-2'
}];
export function Photos() {
  return <section id="photos" className="relative w-full bg-[var(--vu-black)] py-20 px-5 overflow-hidden grain" data-id="element-74" data-mp="qi3y38qicgpn">
      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-75" data-mp="ll3ud4h4rq1p">
        <p className="font-cond uppercase tracking-[0.4em] text-[var(--vu-gold)] text-xs mb-2" data-id="element-76" data-mp="2sbtje6il4qwn">
          The Wall
        </p>
        <h2 className="font-display uppercase text-[var(--vu-cream)] text-5xl sm:text-6xl leading-none" data-id="element-77" data-mp="2ndi5nkp65w95">
          Photos
        </h2>
        <BadgeDivider label="✶" data-id="element-78" data-mp="2trnpl7a1ephc" />

        <div className="mt-8 columns-2 gap-5 text-left sm:columns-3 sm:gap-7" data-id="element-79" data-mp="2tqw2ylyf4237">
          {TILES.map((tile, index) => <motion.figure key={tile.img} initial={{
          opacity: 0,
          scale: 0.9,
          y: 16
        }} whileInView={{
          opacity: 1,
          scale: 1,
          y: 0
        }} whileHover={{
          rotate: 0,
          y: -4,
          zIndex: 10
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} style={{
          rotate: tile.rotate
        }} className={`mb-6 inline-block w-full break-inside-avoid bg-[var(--vu-cream)] p-2 pb-4 border-2 border-[var(--vu-black)] shadow-[5px_5px_0_0_var(--vu-navy)] transition-shadow hover:shadow-[7px_9px_0_0_var(--vu-red)] sm:mb-8 ${tile.offsetClass}`} data-id="element-80" data-mp="2yrtmb1v5z26a" data-mpi={index}>
              <div className="border border-[var(--vu-black)]/20 bg-[var(--vu-cream)]" data-id="element-81" data-mp="1s9wt7a247zcb">
                <img src={tile.img} alt={tile.alt} className="block h-auto w-full max-w-full object-contain" loading="lazy" data-id="element-82" data-mp="1krp1i454rldy" />
              </div>
              <figcaption className="mt-2 font-cond uppercase tracking-widest text-[10px] text-[var(--vu-black)]/60" data-id="element-83" data-mp="1areqmq6kiq1y">
                {tile.caption}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}